module.exports = __webpack_public_path__ + "static/media/slogan.9d194218.svg";